/** Public developer ship log — edit this file when you ship. */
export const CHANGELOG_ENTRIES = [
  {
    date: '2026-04-01',
    title: 'Legal & Stripe',
    items: [
      'Shipped Privacy Policy, Terms of Service, and Refund Policy with site-wide footer links.',
    ],
  },
  {
    date: '2026-04-01',
    title: 'Product',
    items: [
      'Signed-in home dashboard uses Analytics overview.',
      'Messages: Connected Accounts & Auto Reply moved next to type filters.',
    ],
  },
  {
    date: '2026-04-01',
    title: 'Digital trail',
    items: [
      'Added official X, Facebook, and LinkedIn links plus this changelog.',
    ],
  },
];
